export default __webpack_public_path__ + "static/media/vaccineIllustration1.61704861.gif";